import NewEventBanner from "./views/NewEventBanner";
import News from "./views/News";
import ConferenceEvent from "./views/ConferenceEvent";
import RegisterNew from "./views/RegisterNew";
import { useState } from "react";
import sukien1 from "../../assets/images/NewEvent/sukien1.webp";

export default function NewEvent() {
  const [showImage, setShowImage] = useState(false);

  return (
    <div className="pt-[71px] w-full">
      <NewEventBanner />
      <News />
      <ConferenceEvent />
      <RegisterNew />
    </div>
  );
}
